export default function chatIsValid(errors) {  
    return !Object.values(errors).some(err => err)
}